'use client';

import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { CartCount } from '@/entities/cart';
import { useGetPageUrl } from '@/schema/useGetPageUrl';
import { Link } from '@/shared/i18n/navigation';
import { Icon } from '@/shared/ui/icon';
import './cart-button.scss';

type Props = {
    showText?: boolean;
    countProps?: ComponentProps<typeof CartCount>;
};
export const CartButton = ({ showText = true, countProps }: Props) => {
    const t = useTranslations();
    const getPageUrl = useGetPageUrl();
    const cartUrl = getPageUrl('cart');
    return (
        <Link href={cartUrl} className="cart-button" data-testid="navbar-cart-button">
            <div className="cart-button__icon-wrapper">
                <Icon name="bag" width={40} height={40} data-testid="navbar-cart-icon" />
                <CartCount className="cart-button__count" {...countProps} />
            </div>
            {showText && (
                <span className="cart-button__text" data-testid="navbar-cart-text">
                    {t('NAVBAR.CART')}
                </span>
            )}
        </Link>
    );
};
